<app-button
    icon="pi-book"
    label="ePrescriptions.magistraliterRecipes.open"
    severity="secondary"
    [outlined]="true"
    [disabled]="store.opened()"
    (clickEvent)="open()"
></app-button>
